export class InputDataModel {
  public currentValue: string;
  public FormControlValue: any;
  constructor() {
    this.currentValue = '';
    this.FormControlValue = '';
  }
}
